import Result from "./result.js";

class ResultList {
  constructor(element, highlighter) {
    this.element = element;
    this.highlighter = highlighter;
    this.state = "hidden";
    this.observers = [];
  }

  show() {
    if (this.state === "visible") return;
    this.state = "visible";
    this.element.classList.add("show");
  }

  hide() {
    if (this.state === "hidden") return;
    this.state = "hidden";
    this.element.classList.remove("show");
  }

  populate(results, searchText) {
    this.clear();

    if (results.length === 0 || searchText === "") {
      if (this.state === "visible") this.hide();
      return;
    }

    const listItems = document.createDocumentFragment();

    for (const result of results) {
      const listItem = new Result(result, searchText, this.highlighter);
      listItem.addObserver(this.notifyObservers.bind(this));
      listItems.appendChild(listItem.element);
    }

    this.element.append(listItems);
    if (this.state === "hidden") this.show();
  }

  clear() {
    this.element.innerHTML = "";
  }

  addObserver(observer) {
    this.observers.push(observer);
  }

  notifyObservers(projectID, matchedText) {
    for (const observer of this.observers) {
      observer(projectID, matchedText);
    }
  }
}

export default ResultList;
